import * as React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import { useTranslation } from 'react-i18next'
import {useSelector} from "../Redux";
import {Redirect} from "react-router-dom";
import { GetState, GetStateFromData } from './CustomHooks/CustomHooks';

const useStyles = makeStyles({
  '@global': {
    '*::-webkit-input-placeholder': { 
      color: "#606060",
      // color: "#C4C4C4",
    }
    // '*::-webkit-scrollbar': {
    //   width: '10px',
    //   height: '50px',
    // },
    // '*::-webkit-scrollbar-track': {
    //   '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
    // },
    // '*::-webkit-scrollbar-thumb': {
    //   backgroundColor: 'rgba(0,0,0,.1)',
    //   outline: '1px solid slategrey'
    // }
  },
  button: {
    position: 'relative',
  },
  data: {
    fontSize: "15px",
    fontWeight: "bold",
  },
  dialog: {
    position:"absolute",
    height:"299px",
    width:"365px",
    maxWidth:"100%",
    overflow: "hidden",
    borderRadius: "0px",
    direction: window?.psh_configs?.selectedLanguage==="ar" || window?.psh_configs?.selectedLanguage==="ar-SA" ?  "rtl" : "ltr",
  },
  dialogTitle: {
    padding: "16px",
    width:"100%",
    height:"50px"
  },
  dialogHead: { 
    flex: 1, 
    display: 'flex'
  },
  dialogHead1: {
    textAlign: "left",
    color: "#000000",
    font:"normal normal 600 14px/19px Open Sans", 
    letterSpacing: "0px",
  },
  dialogHead2: {
    flex: 1,
    display: 'flex', 
    justifyContent: 'flex-end'
  },
  dialogHeadIcon: {
    height:"14px",
    width:"14px",
  },
  dialogContent: {
    padding: "0px",
    width:"100%",
    overflow:"hidden",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    opacity: 1,
    paddingTop: "19px"
  },
  dialogContentText: {
    textAlign: "left",
    letterSpacing: "0px",
    color: "#606060",
    font: "normal normal bold 12px/17px Open Sans",
    paddingTop: "38px"
  },
  contentText : {
    // display: "flex",
    // padding: "0px 25px"
  },
  dialogActions: {
    height: "50px",
    width:"100%",
    background: "#F8F8F8 0% 0% no-repeat padding-box",
    opacity: 1,
    padding: "11px 16px",
  },
  btn1: {
    width: "101px",
    height: "28px",
    background: "#0072C6 0% 0% no-repeat padding-box",
    border: "1px solid #C4C4C4",
    borderRadius: "2px",
    opacity: 1,
    padding: "5px 8px 6px 8px",
  },
  btnlabel: {
    textTransform: "none",
    font: "normal normal 600 11px/14px Open Sans"
  },

  closeIcon:{
    fontSize: 10,
  },


});

export default function SessionExpired(props) {
  // const [open, setOpen] = React.useState(false);
  const {open, onClose} = props;
  const classes = useStyles();

  const { t } = useTranslation(['styles', 'translation']);

  const contexts = GetStateFromData(props.containerId);

  
  const {globalTime, setGlobalTime, sessionPopupTime, sessionTime }=contexts.contexts;

  const handleClick = () => {
    setGlobalTime({...globalTime , min:sessionTime, sec:  0});
    onClose();
  };

  //  console.log("time..", globalTime, sessionPopupTime, sessionTime);


  const handleClose = () => {
    onClose();
  };

  let timerStyle = {
    textAlign: "left",
    letterSpacing: "0px",
    color: "#0072C6",
    font: "normal normal bold 12px/17px Open Sans",
    display: "inline-block",
    paddingLeft: "2px"
  }

  return (
    <div>
     
      <Dialog  classes={{paper:classes.dialog}}  open={open} >
     
        
        <DialogTitle classes={{root:classes.dialogTitle}}>
            <div className={classes.dialogHead} >
                <div  className={classes.dialogHead1}>
                {t(`translation:${"Session Expired"}`)}
                </div>
                {/* <div className={classes.dialogHead2}>
                  <img src={require("../Icons/PickListIcons/Cancel.svg").default} onClick = {handleClose} className={classes.dialogHeadIcon} />
                </div> */}
            </div>
            
        </DialogTitle>
        
        <Divider className={classes.divider}/>

        <DialogContent classes={{root:classes.dialogContent}} >
          <img src={require("../Icons/SessionTimeout.svg").default} style={{width:"110px", height:"110px"}} alt='Session Timeout Icon'/>
          <DialogContentText classes={{root:classes.dialogContentText}}> 
          {globalTime.min === 0 && globalTime.sec ===0 ? 
            <>
              <Redirect to={`/errorpage`}/>
              {/* <div className={classes.contentText}>
                {t(`translation:${"Your session has expired. You are logged out."}`)} 
              </div>
              <div> {t(`translation:${"Click here to"}`)} <Link href={window.location.pathname} classes={{root:classes.timerStyle}} > {t(`translation:${"relogin"}`)} </Link> </div> */}
             </>
            :
            <div>  
              {t(`translation:${"Your session has expired. You will be logged out in"}`)} 
              <div style={timerStyle}> {globalTime.min < 10 ? `0${globalTime.min}` : globalTime.min }:{globalTime.sec < 10 ? `0${globalTime.sec}` : globalTime.sec } </div>
          
            </div>  
          } 
           </DialogContentText> 
           
          
        </DialogContent>
        

        <DialogActions classes={{root:classes.dialogActions}}>
            <Button className="formBuilder-MuiButton-outlined"
                            disableFocusRipple
                            disableRipple
                            tabIndex={0} classes={{root:classes.btn1,label:classes.btnlabel}} style={{display: (globalTime.min === 0 && globalTime.sec ===0) ? "none" : "block" }} size="small" variant="contained" color="primary" onClick={handleClick} > {t(`translation:${"Stay Logged In"}`)} </Button>    
        </DialogActions>
    </Dialog>
    </div>
  );
}
